import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { streamsSlice } from "@common/redux/slices/entities.slice";
import { streamsBannersSlice } from "@common/redux/slices/streamsBanners.slice";
import { Layout } from "@kursk/components/Layout/Layout";
import styles from './Streams.module.scss';
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { Filters } from "./Filters/Filters";
import { StreamsGrid } from "./StreamsGrid/StreamsGrid";
import { Banner } from "./Banner/Banner";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import React from "react";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const Streams = () => {
  const { total, meta, filters } = useSelectSlice(streamsSlice);
  const { items } = useSelectSlice(streamsBannersSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles
        page="streams"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, 'Трансляции')}
        meta={meta}
      />
      {items.length > 0 && (
        <section className={styles.banners}>
          <Banner banners={items}/>
        </section>
      )}
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            page="streams"
            tags={meta.tags}
            selectedTags={selectedTags}
            title={'Трансляции'}
            dashTitle={'Найдено трансляций'}
            total={total}
          />
        </div>
        <div className={styles.filters}>
          <Filters/>
        </div>
        <div className={styles.items}>
          <StreamsGrid/>
        </div>
        <div className={styles.section}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
